import { Roles, usePermissionsContext } from "@contexts/PermissionsContext";
const useRoles = () => {
    const { roles, setRoles, rolesNoImpersonation } = usePermissionsContext();
    const hasAdminRoleNoImpersonation = rolesNoImpersonation.some((role) => role === Roles.Admin); // Check if the user has the admin role, without considering impersonation
    const hasAdminRole = roles.some((role) => role === Roles.Admin);
    const hasPlanWriteRole = roles.some((role) => role === Roles.PlanWriter || role === Roles.Admin);
    return { roles, setRoles, hasAdminRole, hasPlanWriteRole, hasAdminRoleNoImpersonation };
};
export default useRoles;
